import { Link as RouterLink } from "react-router-dom";
import TalentTalkslogo from "../assets/newlogo/VIRIQO_HIRES_Logo.png";

const PublicHeader = () => {
  return (
    <header
    className="sticky top-0 z-50 w-full flex items-center justify-between
    px-6 sm:px-10 lg:px-16 py-3
    border-b-4 border-transparent
    [border-image:linear-gradient(90deg,_#00AEEF,_#3A5BC7,_#6A1B9A)_1]
    bg-white dark:bg-gray-900
    backdrop-blur-xl shadow-sm
    transition-all duration-300"
    >
      {/* Logo Section */}
      <div className="flex items-center w-full">
        <RouterLink to="/" className="inline-block">
          <img
            src={TalentTalkslogo}
            alt="TalentTalks Logo"
            style={{
              height: "auto",
              maxHeight: "45px",
              width: "auto",
              minWidth: "150px",
              objectFit: "contain",
            }}
            className="transition-opacity duration-300 hover:opacity-90 cursor-pointer"
          />
        </RouterLink>
      </div>
    </header>
  );
};

export default PublicHeader;
